import React from 'react'
import styled from 'styled-components';
const BtnStyle = styled.div`
  width: 100%;
  background: linear-gradient(270deg, #80C80F 0%, #229F20 100%);
  border-radius: 5px;
  text-align: center;
  text-decoration: none;
  line-height: 52px;
  color: #FFFFFF;
  a {
    color: #FFFFFF;
    width: 100%;
    display: inline-block;
  }
  &:hover {
    background: linear-gradient(270deg,#74b310 0%,#147713 100%);
  }
  .fa {
    font-size: 18px;
    margin-left: 5px;
  }
`;

export default function ViewBtn(props) {
  return (
    <BtnStyle>
      <a href={props.href}>
        {props.children || 'view'}
        <i className="fa fa-arrow-right"></i>
      </a>
    </BtnStyle>
  )
}
